// extracted by mini-css-extract-plugin
export var parcelRow = "_r5-0";